
import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface CodeHighlighterProps {
  code: string;
  language: string;
}

const CodeHighlighter: React.FC<CodeHighlighterProps> = ({ code, language }) => {
  // Map our language values to those supported by the syntax highlighter
  const mapLanguage = (lang: string): string => {
    const languageMap: Record<string, string> = {
      javascript: 'javascript',
      typescript: 'typescript',
      python: 'python',
      html: 'html',
      css: 'css',
      java: 'java',
      c: 'c',
      cpp: 'cpp',
      csharp: 'csharp',
      go: 'go',
      ruby: 'ruby',
      rust: 'rust',
      php: 'php',
      swift: 'swift',
      kotlin: 'kotlin',
      // Add fallback mappings for file extensions
      js: 'javascript',
      ts: 'typescript',
      py: 'python',
      htm: 'html',
      jsx: 'jsx',
      tsx: 'tsx',
    };
    
    // Check if language is a file extension first
    const languageToUse = lang.toLowerCase();
    return languageMap[languageToUse] || 'text';
  };
  
  return (
    <SyntaxHighlighter
      language={mapLanguage(language)}
      style={atomDark}
      customStyle={{
        margin: 0,
        padding: '1rem',
        borderRadius: '4px',
        minHeight: '100%',
        background: 'transparent',
        lineHeight: '1.5', // Added explicit line height
      }}
      codeTagProps={{
        style: {
          fontSize: 'inherit',
          fontFamily: 'inherit',
        },
      }}
    >
      {code || ' '}
    </SyntaxHighlighter>
  );
};

export default CodeHighlighter;
